import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { get, toInteger } from 'lodash';
import CategoryDropdown from './category-dropdown';
import messages from '../../utils/messages';

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: props.searchTerm,
      availableFacets: props.availableFacets,
      facetId: props.facetId,
    }
  }

  componentWillReceiveProps({ searchTerm, availableFacets, facetId }) {
    this.setState({ searchTerm, availableFacets, facetId })
  }

  handleChange = (event) => {
    this.setState({ facetId: event.target.value })
  };

  render() {
    const { updateRecallsSearch, resetSelection } = this.props;
    const { searchTerm, availableFacets, facetId } = this.state;
    const { formatMessage } = this.props.intl;
    return (
      <div className="container-fluid container-green index notranslate">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 text-center step0">
              <form onSubmit={e => {
                e.preventDefault();
                updateRecallsSearch(searchTerm, facetId)
              }}>
                <div className="input-group my-group">
                  <CategoryDropdown
                    availableFacets={availableFacets}
                    facetId={facetId}
                    handleChange={this.handleChange}
                  />
                  <input
                    type="text"
                    value={searchTerm || ''}
                    onChange={event => this.setState({ searchTerm: event.target.value })}
                    className="form-control input-lg option1"
                    placeholder={formatMessage(messages.searchTermPlaceholder)}
                  />
                  {searchTerm &&
                  <span className="input-group-btn">
                      <button
                        type="button"
                        className="btn btn-primary btn-lg reset-btn"
                        onClick={e => resetSelection(true)}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </span>
                  }
                  <span className="input-group-btn">
    						  <button className="btn btn-primary btn-lg" type="submit">
                    <FormattedMessage id="search.button"/>
                  </button>
    						</span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(SearchBar);



// WEBPACK FOOTER //
// ./src/views/recalls-list/search-bar.js